import { ComponentType, type IConfig } from '../../types';

import { config as EditorConfig } from '../editor/config';

export const config: IConfig = {
  component: ComponentType.FormEditor,
  configGroups: [...EditorConfig.configGroups],
};
